module.exports = __webpack_public_path__ + "static/media/logo.57d4cf75.psd";